import { colors } from 'config';
import { getCurrentFont, isFitanu } from 'config/theme';
import img from 'images';

import { Button as BaseButton, Grid, styled, Typography } from '@material-ui/core';

const BUTTON_WIDTH = 175;
const BUTTON_HEIGHT = 57;
const BUTTON_WIDTH_FITANU = 175;
const BUTTON_HEIGHT_FITANU = 42;
const BUTTON_WIDTH_xs = 160;
const BUTTON_HEIGHT_xs = 32;

export const Wrapper = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100vh",
  boxSizing: "border-box",
  ...(isFitanu()
    ? {
        backgroundImage: `url('${img.footerBackground.FITANU}')`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
      }
    : {
        backgroundColor: colors.landing.red,
        justifyContent: "center",
        position: "relative",
      }),
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "auto",
  },
}));

export const ReadMoreWrapper = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(6),
  alignItems: "start",
  display: "flex",
  flexDirection: "row",
  justifyContent: "top",
  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

export const ReadMoreText = styled(Grid)(({ theme }) => ({
  width: "70%",
  display: "flex",
  flexDirection: "column",
}));

export const LanguageWrapper = styled(Grid)(({ theme }) => ({
  position: "absolute",
  width: 100,
  height: 50,
  top: 10,
  right: 20,
  zIndex: 9999,
}));

export const LeftContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  boxSizing: "border-box",
  padding: theme.spacing(10.5, 0, 11, 18),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  [theme.breakpoints.down("lg")]: {
    padding: theme.spacing(9.5, 0, 10, 14),
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(8, 0, 8, 10),
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(8, 4.5, 12, 4.5),
  },
}));

export const Button = styled(BaseButton)(({ theme }) => ({
  width: isFitanu() ? BUTTON_WIDTH_FITANU : BUTTON_WIDTH,
  height: isFitanu() ? BUTTON_HEIGHT_FITANU : BUTTON_HEIGHT,
  fontSize: 17,

  marginTop: theme.spacing(2),
  boxSizing: "border-box",
  border: isFitanu()
    ? `2px solid ${theme.palette.common.white}`
    : `4px solid ${theme.palette.common.white}`,
  whiteSpace: "nowrap",
  ...(isFitanu()
    ? {
        backgroundColor: colors.landing.fitanuBlack,
        "&:hover": {
          backgroundColor: theme.palette.grey[300],
        },
      }
    : {
        borderRadius: "10px",
        color: theme.palette.common.white,
      }),
  [theme.breakpoints.down("sm")]: {
    width: BUTTON_WIDTH_xs,
    height: BUTTON_HEIGHT_xs,
    fontSize: 15,
  },
}));

export const RightContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  position: "relative",
  boxSizing: "border-box",
  zIndex: 9999,
  color: "white",
  overflow: "visible",
  [theme.breakpoints.down("sm")]: {
    minHeight: 530,
    padding: theme.spacing(8, 5),
  },
}));

export const Container = styled("div")(({ theme }) => ({
  height: "80%",
  boxSizing: "border-box",
  width: "100%",
  padding: theme.spacing(10.5, 0, 11, isFitanu() ? 18 : 0),
  display: "flex",
  flexDirection: "column",
  margin: "0 20% 0 35%",
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(8, 0, 8, 8),
  },
  [theme.breakpoints.down("sm")]: {
    margin: 0,
    padding: theme.spacing(8, 4.5, 2, 4.5),
  },
}));

export const ImagesWrapper = styled(Grid)(({ theme }) => ({
  width: "100%",
  boxSizing: "border-box",
  position: "absolute",
  left: 0,
  ...(isFitanu()
    ? { height: "85%", top: "7%" }
    : { height: "20%", bottom: "0" }),
}));

export const PhoneImage = styled("img")(({ theme }) => ({
  ...(isFitanu()
    ? {
        position: "absolute",
        height: "100%",
        left: "10%",
        [theme.breakpoints.down("sm")]: {
          height: "125%",
          left: "14%",
          top: "-10%",
        },
      }
    : {
        position: "absolute",
        zIndex: 9999,
        width: "30%",
        bottom: "-60%",
        right: "0%",

        [theme.breakpoints.down("sm")]: {
          width: "50%",
          height: "auto",
          right: "auto",
          left: "65%",
          bottom: "60%",
          zIndex: 1,
        },
        [theme.breakpoints.down("xs")]: {
          bottom: "80%",
          width: "53%",
        },
      }),
}));

export const LeftImage = styled("img")(({ theme }) => ({
  position: "absolute",
  width: "30%",
  bottom: "0%",
  left: "4%",
  zIndex: 99,
  [theme.breakpoints.down("sm")]: {
    height: "0%",
  },
}));

export const PromotionImage = styled("img")(({ theme }) => ({
  height: "50%",
  marginRight: "2%",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "30%",
    height: "40px",
  },
}));

export const CardImage = styled("img")(({ theme }) => ({
  position: "absolute",
  height: "30%",
  bottom: 0,
  left: "27%",
  [theme.breakpoints.down("sm")]: {
    height: "35%",
    left: "10%",
    top: 0,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily: getCurrentFont("korolev, sans-serif"),
  fontStyle: "normal",
  width: "80%",
  ...(isFitanu()
    ? {
        color: theme.palette.common.black,
        fontSize: 20,
        lineHeight: "31px",
        fontWeight: 700,
      }
    : {
        color: theme.palette.common.white,
        fontSize: 16,
        lineHeight: "20px",
        fontWeight: 300,
      }),
  [theme.breakpoints.down("sm")]: {
    fontSize: 15,
    fontWeight: isFitanu() ? 700 : 300,
    lineHeight: "20px",
  },
}));

export const DownloadTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4),
  color: theme.palette.common.black,
  fontSize: 23,
  lineHeight: "24px",
  width: "auto",
  fontWeight: isFitanu() ? 700 : "normal",
  [theme.breakpoints.down("sm")]: {
    fontSize: 18,
    fontWeight: isFitanu() ? 700 : 500,
    lineHeight: "20px",
  },
  [theme.breakpoints.up("md")]: {
    marginBottom: theme.spacing(2),
    width: "auto",
  },
}));

export const JoinImg = styled("img")(({ theme }) => ({
  alignSelf: "flex-start",
  height: isFitanu() ? "auto" : "46%",
  width: isFitanu() ? "100%" : "auto",
  [theme.breakpoints.down("sm")]: {
    width: "94%",
    height: "auto",
  },
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    width: "100%",
  },
}));

export const JoinTitle = styled(Typography)(({ theme }) => ({
  wordBreak: "break-word",
  marginBottom: isFitanu() ? theme.spacing(4.5) : 0,
  textTransform: isFitanu() ? "uppercase" : "none",
  fontFamily: getCurrentFont("korolev"),
  color: isFitanu() ? theme.palette.common.black : theme.palette.common.white,
  fontSize: isFitanu() ? 31 : 80,
  lineHeight: isFitanu() ? "31px" : "88px",
  letterSpacing: 1.5,
  fontWeight: 700,
  [theme.breakpoints.down("sm")]: {
    marginBottom: isFitanu() ? theme.spacing(3) : 0,
    fontSize: 48,
    letterSpacing: 1,
    fontWeight: 700,
    lineHeight: "52.8px",
  },
}));

export const BottomJoinTitle = styled(JoinTitle)(({ theme }) => ({
  color: colors.landing.gold,
  whiteSpace: "nowrap",
  [theme.breakpoints.down("sm")]: {
    whiteSpace: "normal",
  },
}));

export const ShopWrapper = styled(Grid)(({ theme }) => ({
  paddingLeft: "13%",
  backgroundColor: theme.palette.common.white,
  height: "25%",
  marginLeft: "15%",
  width: "85%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    paddingLeft: 0,
    paddingBottom: "5%",
    marginLeft: "0%",
    zIndex: 9999,
  },
}));

export const ShopContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: "70%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    zIndex: 9999,
    justifyContent: "center",
  },
}));

export const ButtonsWrapper = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "80%",
  justifyContent: "center",
  "& > button": {
    width: "50%",
  },
  "& > button:first-child": {
    marginRight: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  [theme.breakpoints.down("sm")]: {
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    maxWidth: 360,
    "& > button": {
      marginTop: theme.spacing(2),
    },
  },
}));
